var map = {
	"./__tests__/lti.resourceImported.test.js": [
		"LFe7",
		4210
	],
	"./__tests__/lti.screenReaderAlert.test.js": [
		"0Guc",
		4211
	],
	"./__tests__/lti.showAlert.test.js": [
		"+y7l",
		4212
	],
	"./__tests__/org.imsglobal.lti.get_data.test.js": [
		"CXUv",
		4197
	],
	"./__tests__/org.imsglobal.lti.put_data.test.js": [
		"mElt",
		4198
	],
	"./__tests__/requestFullWindowLaunch.test.js": [
		"o6ta",
		4213
	],
	"./lti.enableScrollEvents.js": [
		"HVU3",
		4270
	],
	"./lti.fetchWindowSize.js": [
		"OANa",
		4271
	],
	"./lti.frameResize.js": [
		"bSyB",
		4199
	],
	"./lti.removeUnloadMessage.js": [
		"tjuu",
		4214
	],
	"./lti.resourceImported.js": [
		"FC2N",
		4272
	],
	"./lti.screenReaderAlert.js": [
		"YYEg",
		4273
	],
	"./lti.scrollToTop.js": [
		"W/R1",
		4274
	],
	"./lti.setUnloadMessage.js": [
		"6fDN",
		4215
	],
	"./lti.showAlert.js": [
		"onLg",
		4275
	],
	"./lti.showModuleNavigation.js": [
		"NSTA",
		4276
	],
	"./org.imsglobal.lti.capabilities.js": [
		"zPPZ",
		4277
	],
	"./org.imsglobal.lti.get_data.js": [
		"lH2A",
		4208
	],
	"./org.imsglobal.lti.put_data.js": [
		"hugc",
		4209
	],
	"./requestFullWindowLaunch.js": [
		"8IHO",
		4278
	],
	"./toggleCourseNavigationMenu.js": [
		"ECMy",
		4207
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "G4i8";
module.exports = webpackAsyncContext;